module.exports = __webpack_public_path__ + "static/media/BR-colored-small.25891a6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/BR-colored-small.svg
// module id = 4022
// module chunks = 0